(function () {
  const CONFLICT_ZIP_PATTERN = /^40699/;
  const TOURS = [
    {
      label: 'Gerresheim-Alt-Erkrath-Hubbelrath',
      zip: '40699-Tour1',
    },
    {
      label: 'Hochdahl-Unterfeldhaus-Unterbach',
      zip: '40699-Tour2',
    },
  ];

  const SELECTOR = '#ds-zip-code';

  function injectPopup(inputEl) {
    if (document.getElementById('ds-tour-popup')) return;

    const overlay = document.createElement('div');
    overlay.id = 'ds-tour-popup';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.65);
      backdrop-filter: blur(4px);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: dsFadeIn 0.2s ease;
    `;

    overlay.innerHTML = `
      <style>
        @keyframes dsFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes dsSlideUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        #ds-tour-modal {
          background: #ffffffff;
          border: 1px solid #333333;
          border-radius: 12px;
          padding: 28px 24px;
          width: 320px;
          max-width: 90vw;
          animation: dsSlideUp 0.25s ease;
          box-shadow: 0 8px 40px rgba(0,0,0,0.8);
        }
        #ds-tour-modal h3 {
          margin: 0 0 6px;
          font-size: 15px;
          font-weight: 700;
          color: #1f1010;
          letter-spacing: 0.03em;
        }
        #ds-tour-modal p {
          margin: 0 0 20px;
          font-size: 12px;
          color: #888888;
          line-height: 1.5;
        }
        .ds-tour-cards {
          display: flex;
          gap: 10px;
        }
        .ds-tour-card {
          flex: 1;
          border: 1.5px solid #ffffffff;
          border-radius: 8px;
          padding: 14px 10px;
          text-align: center;
          cursor: pointer;
          transition: border-color 0.15s, background 0.15s;
          background: #888888;
          color: #ffffffff;
          font-size: 13px;
          font-weight: 600;
        }
        .ds-tour-card:hover {
          border-color: #888888;
          background: #888888;
          color: #ffffff;
        }
        .ds-tour-card.selected {
          border-color: #000000ff;
          background: #000000ff;
          color: #ffffff;
        }
        .ds-tour-card span {
          display: block;
          font-size: 10px;
          font-weight: 400;
          color: #ffffffff;
          margin-top: 4px;
        }
        .ds-tour-card.selected span {
          color: #ffffffff;
        }
        #ds-tour-confirm {
          margin-top: 18px;
          width: 100%;
          padding: 12px;
          background: #cc0000;
          color: #ffffff;
          font-weight: 700;
          font-size: 13px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: background 0.15s;
        }
        #ds-tour-confirm:hover {
          background: #e60000;
        }
        #ds-tour-close {
          position: absolute;
          top: 14px;
          right: 16px;
          background: none;
          border: none;
          color: #666666;
          font-size: 18px;
          cursor: pointer;
          line-height: 1;
        }
        #ds-tour-close:hover {
          color: #ffffff;
        }
        #ds-tour-modal {
          position: relative;
        }
      </style>

      <div id="ds-tour-modal">
        <button id="ds-tour-close">✕</button>
        <h3>Liefergebiet wählen</h3>
        <p>PLZ 40699 liegt in zwei Touren.<br>Bitte wähle dein Gebiet:</p>
        <div class="ds-tour-cards">
          ${TOURS.map((t, i) => `
            <div class="ds-tour-card ${i === 0 ? 'selected' : ''}" data-zip="${t.zip}">
              ${t.label}
              <span>${t.zip}</span>
            </div>
          `).join('')}
        </div>
        <button id="ds-tour-confirm">Bestätigen</button>
      </div>
    `;

    document.body.appendChild(overlay);

    let selectedZip = TOURS[0].zip;

    // Card-Auswahl
    overlay.querySelectorAll('.ds-tour-card').forEach((card) => {
      card.addEventListener('click', function () {
        overlay.querySelectorAll('.ds-tour-card').forEach(c => c.classList.remove('selected'));
        this.classList.add('selected');
        selectedZip = this.dataset.zip;
      });
    });

    // Bestätigen
    overlay.querySelector('#ds-tour-confirm').addEventListener('click', () => {
      inputEl.value = selectedZip;
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      overlay.remove();
    });

    // Schließen
    overlay.querySelector('#ds-tour-close').addEventListener('click', () => {
      overlay.remove();
    });

    // Klick außerhalb schließt Popup
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });
  }

  function handleZipInput(e) {
    const val = e.target.value.trim();
    if (CONFLICT_ZIP_PATTERN.test(val) && !document.getElementById('ds-tour-popup')) {
      injectPopup(e.target);
    } else if (!CONFLICT_ZIP_PATTERN.test(val)) {
      const popup = document.getElementById('ds-tour-popup');
      if (popup) popup.remove();
    }
  }

  const observer = new MutationObserver(() => {
    const input = document.querySelector(SELECTOR);
    if (input && !input._dsListenerAttached) {
      input.addEventListener('input', handleZipInput);
      input.addEventListener('change', handleZipInput);
      input._dsListenerAttached = true;

      if (CONFLICT_ZIP_PATTERN.test(input.value.trim())) {
        injectPopup(input);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
